import { render, staticRenderFns } from "./Ods.vue?vue&type=template&id=bbf93dd6&scoped=true"
import script from "./Ods.vue?vue&type=script&lang=js"
export * from "./Ods.vue?vue&type=script&lang=js"
import style0 from "./Ods.vue?vue&type=style&index=0&id=bbf93dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf93dd6",
  null
  
)

export default component.exports